'use client'

import { useRouter } from 'next/navigation'
import { memo, useMemo, type FC } from 'react'
import styled from 'styled-components'
import { SliderFlickity } from '../../base'
import { SlideContent } from './SlideContent'
import { designGrid, mq, vw } from '@/styles'
import { TypeCmsVariant } from '@/schema'

type Props = {
  data: TypeCmsVariant[]
};

const getSliders = (data, push) => {
  if (!data || !Array.isArray(data)) return []

  return data.map((slide, idx) => (
    <SlideContent key={idx} slide={slide} onNavigate={push} index={idx} />
  ))
}

const headingId = 'highlighted-categories'
export const SectionHighlightedCategories:FC<Props> = memo(({ data }) => {
  const { push } = useRouter()
  const slides = useMemo(() => getSliders(data, push), [data, push])

  return (
    <Section aria-labelledby={headingId}>
      <h2 id={headingId}></h2>
      <SliderFlickity
        className='slider--product-highlight fade'
        options={{
          draggable: false,
          autoPlay: 4000,
          pauseAutoPlayOnHover: false,
          initialIndex: 0,
        }}
      >
        {slides}
      </SliderFlickity>
    </Section>
  )
})

const Section = styled.section`
  ${designGrid({})}
  margin-bottom: ${vw(50, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin-bottom: ${vw(50, 'tablet')};
    margin-top: ${vw(70, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    margin-bottom: ${vw(150, 'desktop')};
    margin-top: ${vw(150, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    margin-bottom: 150px;
    margin-top: 150px;
  }

  .slider-wrapper,
  .content-wrapper {
    grid-column: 1 / span 6;
    height: ${vw(447, 'mobile')};
    width: 100%;

    ${mq.greaterThan('nexus7')} {
      height: ${vw(447, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      height: ${vw(715, 'desktop')};
      grid-column: 1 / span 12;
    }
    ${mq.greaterThan('desktop')} {
      height: 715px;
    }
  }

  .content-wrapper {
    ${designGrid({})}

		picture,
    img {
      filter: none;
      grid-column: 1 / span 6;
      grid-row: 1 / span 2;
      height: inherit;
      object-fit: cover;
      pointer-events: none;
      user-select: none;
      width: 100%;

      ${mq.greaterThan('tablet')} {
        grid-area: 1 / 1 / span 1 / span 12;
      }
    }

    &.figure--video {
      grid-area: 1 / 1 / span 2 / span 6;
      filter: none;

      iframe {
        transform: translateX(-50%);
        width: 200% !important;
      }

      ${mq.greaterThan('tablet')} {
        grid-area: 1 / 1 / span 1 / span 12;

        iframe {
          height: 200% !important;
          transform: translate(${vw(50, 'desktop')}, -25%);
          width: calc(100% - ${vw(100, 'desktop')}) !important;
        }
      }
    }

    &.media {
      color: var(--color-white);
    }
  }
`
